import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../redux/store";
import { fetchUserData } from "../../redux/actions/user.actions";
import RegistrationForm from "./components/RegistrationForm";
import AuthLayout from "./components/AuthLayout";

const RegistrationPage: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(fetchUserData());
  }, [dispatch]);

  return (
    <AuthLayout title="Create your account" subtitle="Register to manage your spas." wide>
      <RegistrationForm />
    </AuthLayout>
  );
};

export default RegistrationPage;
